<template>
	<c-dialog ref="dialog" title="编辑公式" width="1000" height="600" enable-flex @resolve="submitHandle">
		<div class="flex-grow flex">
			<div class="field flex-column">
				<div class="field-title">可选字段</div>
				<div class="flex-grow field-list">
					<dl v-for="(group, i) in fieldList" :key="i">
						<dt class="flex-between-center" :class="{'z-fold': group.fold}" @click="$set(group, 'fold', !group.fold)">
							<span>{{group.name}}</span>
							<i class="angle tf-angle-right"></i>
						</dt>
						<dd v-show="!group.fold">
							<ul>
								<li v-for="(item, j) in group.list" :key="j" @click="fieldHandle(group, item)"><span style="margin-right: 8px;">└</span>{{item.field_title}}</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>
			<div class="flex-grow flex-column">
				<div ref="editor" class="flex-grow"></div>
				<!-- <div class="symbol">
					<ul class="flex-wrap">
						<li v-for="(item, i) in symbolList" :key="i" class="flex-center">{{item}}</li>
					</ul>
				</div> -->
			</div>
		</div>
	</c-dialog>
</template>

<script>
	import {EditorView, basicSetup} from 'codemirror'
	import {Decoration, keymap} from '@codemirror/view'
	import {StateField, Prec} from '@codemirror/state'

	const keywords = {
		IF: 'if',
		ELSE: 'else'
	};

	const highlightRegex = {
		field: /\$\{[^\{\}]*\}/g,
		string: /['"]{1}[^'"]*['"]{1}/g,
		number: /\b\d+\.?\d*\b/g
	};

	const markDecorations = {
		field: Decoration.mark({class: 'cm-tag-field'}),
		string: Decoration.mark({class: 'cm-tag-string'}),
		number: Decoration.mark({class: 'cm-tag-number'})
	};

	const regexHighlightField = StateField.define({
		create(state) {
			return Decoration.none;
		},
		update(oldDecorations, tr) {
			if (!tr.docChanged) return oldDecorations;

			const decorations = [];
			const doc = tr.newDoc;
			const text = doc.toString();

			for (const [type, regex] of Object.entries(highlightRegex)) {
				let match;
				regex.lastIndex = 0;
				while ((match = regex.exec(text)) !== null) {
					const from = match.index;
					const to = from + match[0].length;
					decorations.push(markDecorations[type].range(from, to));
				}
			}

			return Decoration.set(decorations, true);
		},
		provide: f => EditorView.decorations.from(f)
	});

	export {
		keywords
	}

	export default {
		name: 'formulaEditor',

		props: {
			workType: Number,
			required: Boolean
		},

		data() {
			return {
				fieldList: [],
				symbolList: ['&&', '||', '==', '!=', '>', '>=', '<', '<=', '()']
			}
		},

		mounted() {
			this.editor = new EditorView({
				parent: this.$refs.editor,
				extensions: [
					basicSetup,
					Prec.highest(
						keymap.of([{
							key: 'Mod-f',
							run: () => true
						}, {
							key: 'Tab',
							run: () => {
								this.insertText('    ');
								return true;
							}
						}])
					),
					EditorView.lineWrapping,
					regexHighlightField
				]
			});
		},

		methods: {
			open(data = {}) {
				this.$refs.dialog.open();
				this.$nextTick(() => {
					let content = data.content || '';
					this.editor.dispatch({
						changes: {
							from: 0,
							to: this.editor.state.doc.length,
							insert: content
						},
						selection: {
							anchor: content.length
						}
					});
					this.editor.focus();
				});

				this.request({
					url: '/formula/field/list',
					data: {
						work_type_id: this.workType
					},
					success: data => {
						this.fieldList = data;
					}
				});
			},

			insertText(text) {
				let cursor = this.editor.state.selection.main.head;
				this.editor.dispatch({
					changes: {
						from: cursor,
						insert: text
					},
					selection: {
						anchor: cursor + text.length
					}
				});
			},

			fieldHandle(group, field) {
				this.insertText(`\${${group.name}.${field.field_title}}`);
				this.editor.focus();
			},
			
			submitHandle(stop) {
				let content = this.editor.state.doc.toString();

				if (this.required && !content.trim()) {
					this.$message({
						message: '公式不能为空'
					});
					stop();
					return;
				}

				let fields = content.match(/\$\{[^\{\}]*\}/g)
				let disable = [];
				fields && fields.forEach(item => {
					let field;
					try {
						let str = item.match(/[^\$\{\}]+/g)[0].split('.');
						field = this.fieldList.find(item => item.name == str[0]).list.find(item => item.field_title == str[1]);
					} catch(e) {}
					!field && disable.push(item);
				});

				if (disable.length) {
					this.$message({
						message: `${disable.join('、')}字段无效，请检查后重试`
					});
					stop();
					return;
				}

				let regex = new RegExp(`\\b(${Object.keys(keywords).join('|')})\\b`, 'g');
				let test = content.replace(regex, match => keywords[match]);

				try {
					new Function(test.replaceAll(/\$\{[^\{\}]*\}/g, '\'1\''))();
				} catch(e) {
					stop();
					this.$message({
						message: '公式运行异常，请检查后重试'
					});
					console.error('公式运行异常\n', e);
					return;
				}
				
				this.$emit('resolve', content);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.field {
		width: 200px;
		border-right: 1px solid #ddd;

		&-title {
			border-bottom: 1px solid #ddd;
			padding: 0 16px;
			line-height: 40px;
			font-weight: bold;
			background: #F5F5F5;
		}

		&-list {
			overflow: auto;

			dl {
				position: relative;

				dt {
					position: sticky;
					top: 0;
					height: 40px;
					padding: 0 10px 0 16px;
					background: #fff;
					cursor: pointer;

					&:hover {
						background: #F5F5F5;
					}

					.angle {
						font-size: 12px;
						color: #999;

						^[-1].z-fold ^[-1..-1] {
							transform: rotate(90deg);
						}
					}
				}

				dd {
					margin-bottom: 6px;

					ul {
						li {
							padding: 0 16px;
							line-height: 30px;
							font-size: 13px;
							cursor: pointer;

							&:hover {
								color: var(--color-main);
								background: #F5F5F5;
							}
						}
					}
				}
			}
		}
	}

	.symbol {
		height: 200px;
		border-top: 1px solid #ddd;

		ul {
			gap: 10px;
			padding: 10px;

			li {
				width: 60px;
				height: 50px;
				border-radius: 4px;
				font-size: 16px;
				background: #F5F5F5;
				cursor: pointer;

				&:hover {
					background: #eee;
				}
			}
		}
	}

	>>> .cm-editor {
		height: 100%;

		&.cm-focused {
			outline: none;
		}

		.cm-lineNumbers .cm-gutterElement,
		.cm-content {
			line-height: 2 !important;
			font-family: -apple-system, Helvetica, Helvetica Neue, PingFang SC, sans-serif !important;
		}

		.cm-selectionLayer {
			z-index: 10 !important;
			pointer-events: none !important;
		}
		.cm-selectionBackground {
			background: #2D64D1 !important;
			opacity: .4 !important;
		}
		.cm-selectionMatch {
			background: none !important;
		}

		[class*=cm-tag] {
			border-radius: 2px;
			padding: 4px 4px;
			font-size: 12px;
			color: #fff;

			[class*=cm-tag] {
				border-radius: 0;
				padding: 0;
				color: inherit;
				background: none;
			}
		}

		.cm-tag {
			&-field {
				background: var(--color-main);
			}

			&-string {
				color: #000;
				background: #ddd;
			}

			&-number {
				color: #000;
				background: #FFFAAD;
			}
		}
	}
</style>